import { withBasePath } from "@/lib/basePath";

/* ---- Hero ---- */
export const heroStats = [
  { icon: "users", value: "1800+", label: "фермеров на платформе" },
  { icon: "globe", value: "45+", label: "стран-покупателей" },
  { icon: "bar-chart", value: "€78M+", label: "экспортировано продукции" },
  { icon: "headphones", value: "24/7", label: "поддержка фермеров" },
];

export type TrustLogo = { name: string; sub?: string; file?: string; flag?: boolean };

export const trustLogos: TrustLogo[] = [
  { name: "MOLDOVA", sub: "INVEST" },
  { name: "AGRICULTURA", sub: "MOLDOVEI" },
  { name: "Moldova Agroindbank", file: withBasePath("/images/partners/maib.svg") },
  { name: "USAID", file: withBasePath("/images/partners/usaid.svg") },
  { name: "UK aid", file: withBasePath("/images/partners/ukaid.svg"), flag: true },
  { name: "World Bank", file: withBasePath("/images/partners/world-bank.svg") },
  { name: "European Investment Bank", file: withBasePath("/images/partners/eib.svg") },
];

export interface NetworkCategory { id: string; emoji: string; color: string; name: string; count: number; }

export const networkCategories: NetworkCategory[] = [
  { id: "all", emoji: "🌱", color: "#52B788", name: "Все категории", count: 892 },
  { id: "vegetables", emoji: "🥦", color: "#52B788", name: "Овощи", count: 243 },
  { id: "fruits", emoji: "🍎", color: "#E25C4A", name: "Фрукты", count: 187 },
  { id: "grain", emoji: "🌾", color: "#D4A017", name: "Зерно", count: 156 },
  { id: "dairy", emoji: "🥛", color: "#7A9BB5", name: "Молочное", count: 98 },
  { id: "meat", emoji: "🥩", color: "#C0617F", name: "Мясо", count: 64 },
  { id: "wine", emoji: "🍷", color: "#9B6DC4", name: "Вино", count: 72 },
  { id: "honey", emoji: "🍯", color: "#DD8A4A", name: "Мёд", count: 32 },
  { id: "nuts", emoji: "🌰", color: "#B07A3A", name: "Орехи", count: 40 },
];

export interface NetworkStat { icon: string; value: string; label: string; link?: boolean; }

export const networkStats: NetworkStat[] = [
  { icon: "home", value: "892", label: "хозяйства", link: true },
  { icon: "leaf", value: "1.26M т", label: "общий объём" },
  { icon: "globe", value: "28", label: "экспортируют", link: true },
  { icon: "layout-grid", value: "12", label: "категорий", link: true },
];

export interface NetworkFeature { icon: string; title: string; text: string; }

export const networkFeatures: NetworkFeature[] = [
  { icon: "locate", title: "Живая карта", text: "Актуальные данные в реальном времени" },
  { icon: "star", title: "Проверенные фермеры", text: "Рейтинги и отзывы реальных покупателей" },
  { icon: "globe", title: "Экспортный потенциал", text: "Хозяйства, готовые к международным поставкам" },
  { icon: "search", title: "Умный поиск", text: "Фильтрация по продукции, объёмам и регионам" },
];

export const volumeLegend = [
  { color: "#A855F7", label: "< 10 т" },
  { color: "#22C55E", label: "10 – 50 т" },
  { color: "#A3E635", label: "50 – 200 т" },
  { color: "#EAB308", label: "200 – 500 т" },
  { color: "#EF4444", label: "> 500 т" },
];

export interface FarmInfoChip { icon: string; label: string; value: string; }
export interface FarmCrop { emoji: string; name: string; volume: string; }
export interface FarmMiniStat { icon: string; value: string; label: string; }
export interface FarmCard { name: string; verified: boolean; location: string; rating: number; reviews: number; image: string; info: FarmInfoChip[]; crops: FarmCrop[]; cropsMore: number; stats: FarmMiniStat[]; }

export const featuredFarm: FarmCard = {
  name: "VINEYARD HARMONY",
  verified: true,
  location: "Кагульский район, с. Баурчи",
  rating: 4.9,
  reviews: 124,
  image: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=480&q=85",
  info: [
    { icon: "package", label: "Общий объём", value: "428 т" },
    { icon: "calendar", label: "Сезон поставок", value: "апр – окт" },
    { icon: "truck", label: "Логистика", value: "Nova Post" },
  ],
  crops: [
    { emoji: "🌾", name: "Пшеница", volume: "280 т" },
    { emoji: "🍎", name: "Яблоки", volume: "12 т" },
    { emoji: "🍇", name: "Виноград", volume: "18 т" },
    { emoji: "🥛", name: "Молоко", volume: "15 т" },
    { emoji: "🌽", name: "Кукуруза", volume: "120 т" },
  ],
  cropsMore: 3,
  stats: [
    { icon: "trending-up", value: "124", label: "сделки" },
    { icon: "shield-check", value: "98%", label: "выполнено" },
    { icon: "shield-check", value: "5 лет", label: "на платформе" },
  ],
};
